var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"15px"}},[_c('b',[_vm._v("\n    "+_vm._s(_vm.roomName(_vm.value.type))+"\n  ")]),_vm._v("\n  "+_vm._s(_vm.summary)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }